// DO NOT EDIT -- generated from fs/services/webber/frontend/display/display.proto

export enum DisplayPrecision {
  PRECISION_INVALID = 0,
  PRECISION_0 = 1,
  PRECISION_2 = 2,
  PRECISION_1 = 3
}

export enum DisplayCurrencyType {
  CURRENCY_INVALID = 0,
  CURRENCY_USD = 1,
  CURRENCY_EUR = 2,
  CURRENCY_GBP = 3,
  CURRENCY_YEN = 4,
  CURRENCY_AED = 5,
  CURRENCY_AUD = 6,
  CURRENCY_BRL = 7,
  CURRENCY_CAD = 8,
  CURRENCY_CLP = 9,
  CURRENCY_ILS = 10,
  CURRENCY_INR = 11,
  CURRENCY_MXN = 12,
  CURRENCY_THB = 13,
  CURRENCY_TRY = 14,
  CURRENCY_CHF = 15,
  CURRENCY_SEK = 16
}

export enum DisplayDurationUnit {
  DURATION_INVALID = 0,
  DURATION_SEC = 1,
  DURATION_MS = 2,
  DURATION_MU = 3,
  DURATION_NS = 4
}

export interface DisplayDuration {
  unit: DisplayDurationUnit;
  /** Whether to scale the unit on the client */
  autoscale: boolean;
}

export interface Display {
  displayPrecision: DisplayPrecision;
  currency?: DisplayCurrencyType;
  /** @deprecated */
  duration?: DisplayDurationUnit;
  /** The percent is stored as a float and needs to be */
  percent?: boolean;
  /**
   * converted (e.g. 0.98)
   * The percent is already converted to the
   */
  percentUnmodified?: boolean;
  /** correct format (e.g. 98 for 98%) */
  number?: boolean;
  displayDuration?: DisplayDuration | null;
}

export namespace Display {
  export enum display_type {
    currency = 2,
    /** @deprecated */
    duration = 3,
    /** The percent is stored as a float and needs to be */
    percent = 4,
    /**
     * converted (e.g. 0.98)
     * The percent is already converted to the
     */
    percentUnmodified = 7,
    /** correct format (e.g. 98 for 98%) */
    number = 5,
    displayDuration = 6
  }

  export function display_type_oneof(m: Display): { opt: display_type.currency, val: DisplayCurrencyType } | { opt: display_type.displayDuration, val: DisplayDuration } | { opt: display_type.duration, val: DisplayDurationUnit } | { opt: display_type.number, val: boolean } | { opt: display_type.percent, val: boolean } | { opt: display_type.percentUnmodified, val: boolean } | null {
    if (m.currency != null) { return { opt: display_type.currency, val: m.currency } }
    if (m.duration != null) { return { opt: display_type.duration, val: m.duration } }
    if (m.percent != null) { return { opt: display_type.percent, val: m.percent } }
    if (m.percentUnmodified != null) { return { opt: display_type.percentUnmodified, val: m.percentUnmodified } }
    if (m.number != null) { return { opt: display_type.number, val: m.number } }
    if (m.displayDuration != null) { return { opt: display_type.displayDuration, val: m.displayDuration } }
    return null;
  }
}
